import { Pill } from "PFComponents/pill";
import { Tooltip } from "PFComponents/tooltip";
import { useTranslation } from "react-i18next";

export type BetaBadgeProps = {
  tooltip?: string;
};

export const BetaBadge = ({ tooltip }: BetaBadgeProps) => {
  const { t } = useTranslation();

  const badge = <Pill small kind="warning" text={t("beta")} />;

  if (!tooltip) {
    return badge;
  }

  return (
    <Tooltip content={tooltip} triggerContainerProps={{ tabIndex: 0 }}>
      {badge}
    </Tooltip>
  );
};
